module.exports = __webpack_public_path__ + "img/sv.2e18cc1e.png";